import styled from '@emotion/styled';
import type { FC } from 'react';
import { useInspectedTracker } from '../../../lib/customHooks';
import { TrackerMessagesTable } from '../TrackerMessagesTable';

export const MessagesTab: FC = () => {
  const inspectedTracker = useInspectedTracker();

  return (
    <Container>
      <TrackerMessagesTable tracker={inspectedTracker} />
    </Container>
  );
};

const Container = styled.div`
  .nav-item,
  .nav {
    border-color: darkgray;
  }

  .nav-link {
    padding: 0.2rem 0.5rem;
  }
`;
